import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import { IDLE_VERYLOW_PRIORITY } from '@office-start/scheduler-service';
import { lazy } from 'react';
export var Upload = withLazyErrorBoundary(lazy(function () {
    return import(
    /*webpackChunkName: "upload-component" */ '@office-start/upload-component');
}), 'Upload', {
    schedulePriority: IDLE_VERYLOW_PRIORITY,
});
//# sourceMappingURL=Upload.js.map